<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (chatReady$ | async) {
  <app-screen-shell
    layout="full-height"
    contentWidth="standard"
    [contentClass]="chat.entityType === 'EVENT' ? 'd-flex flex-column chat-conversation chat-screen-match' : 'd-flex flex-column chat-conversation chat-screen-direct'"
    [title]="chat.displayName"
    [titleActionable]="true"
    titleActionLabelKey="chat.settings"
    (titleAction)="openChatSettings()"
    (back)="goBack()">
    <div class="chat-body">
      <div class="scroll-wrapper">
        @if (showScrollDateLabel) {
          <div class="chat-scroll-date-pill" aria-hidden="true">{{scrollDateLabel}}</div>
        }
        <div class="scroll-parent" id="scrollParent" #scrollMe infiniteScroll debounce
          [infiniteScrollDistance]="scrollDownDistance"
          [infiniteScrollUpDistance]="scrollUpDistance"
          [infiniteScrollThrottle]="throttle"
          (scroll)="onMessageScroll()"
          (scrolled)="onScrollDown()"
          (scrolledUp)="onScrollUp()"
          [scrollWindow]="false"
          [alwaysCallback]="false"
          [fromRoot]="true">
          <div class="search-results chat-messages">
            @for (message of messagesBySenderGrouped; track message; let i = $index) {
              <div class="chat-message-group" [class.is-own]="isOwnMessage(message)">
                <div class="msg">
                  @if (false && message?.marker) {
                    <p class="text-center"><strong
                    style="color: var(--nogosh-chat-marker-text)">{{message?.marker}}</strong></p>
                  }
                  @if (!message?.marker) {
                    <div class="chat-message-row">
                      @if (!isOwnMessage(message)) {
                        <button type="button" class="chat-avatar-button" (click)="openDirectChatFromMessage(message.sender)" title="{{message.sender.nickName}}">
                          <div class="avatar-team avatar-team-md rounded-circle border" [style.backgroundImage]="'url(' + (message.sender.avatar ? message.sender.avatar : '../../assets/images/user1.jpg') + ')'">
                          </div>
                          <span class="sr-only">{{message.sender.nickName}}'s profile image</span>
                        </button>
                      }
                      <div class="chat-bubble-stack">
                        @if (!isOwnMessage(message)) {
                          <div class="msgNick">{{message.sender.nickName}}</div>
                        }
                        <div class="chat-bubbles">
                            @for (senderMessage of message.messages; track senderMessage; let j = $index) {
                              <div class="chat-bubble" [class.chat-bubble-inline]="usesInlineMessageTime(senderMessage)" [class.chat-bubble-stacked]="!usesInlineMessageTime(senderMessage)" [attr.data-created]="senderMessage.created">
                                @if (senderMessage.blockedSender && !senderMessage.revealedBlocked) {
                                  <button type="button" class="btn btn-link p-0 chat-bubble-text" (click)="senderMessage.revealedBlocked = true">
                                    {{ 'chat.blockedMessage' | translate }} · {{ 'chat.showBlockedMessage' | translate }}
                                  </button>
                                } @else {
                                  <div [innerHTML]="senderMessage.html" class="chat-bubble-text"></div>
                                  @if (senderMessage.blockedSender) {
                                    <button type="button" class="btn btn-link p-0" (click)="senderMessage.revealedBlocked = false">{{ 'chat.hideBlockedMessage' | translate }}</button>
                                  }
                                }
                                <span class="msgTime">
                                  @switch (getMessageDateMode(senderMessage.created)) {
                                    @case ('6Days') {
                                      <span>
                                        {{senderMessage.created | localizedDate: "EEEE, MMM d, H:mm" }}
                                      </span>
                                    }
                                    @case ('Days') {
                                      <span>
                                        {{senderMessage.created | localizedDate: "EEEE, H:mm" }}
                                      </span>
                                    }
                                    @case ('Yesterday') {
                                      <span>
                                        {{ 'chat.yesterday' | translate }} {{senderMessage.created | localizedDate: "H:mm" }}
                                      </span>
                                    }
                                    @case ('Today') {
                                      <span>
                                        {{senderMessage.created | localizedDate: "H:mm" }}
                                      </span>
                                    }
                                  }
                                  @if (isOwnMessage(message)) {
                                    @if (isPendingMessage(senderMessage)) {
                                      <i [class]="('match.time' | nogoshIcon) + ' chat-message-status'" aria-hidden="true"></i>
                                    }
                                    @if (isSentMessage(senderMessage)) {
                                      <i [class]="('common.check' | nogoshIcon) + ' chat-message-status'" aria-hidden="true"></i>
                                    }
                                  }
                                </span>
                              </div>
                            }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div id="searchEnd"></div>
        </div>
      </div>
    </div>
    <form class="chat-composer" id="newMessageSection" #chatTextBox (submit)="$event.preventDefault(); submitNewMessage(newMessageText)">
      <textarea class="form-control chat-composer-input" rows="1" name="eventComment" id="newCommentText"
          [(ngModel)]="newMessageText" [placeholder]="'validation.message' | translate"
          (keyup.enter)="submitNewMessage(newMessageText)"
          (blur)="captureBlurEventOnMessageSubmit(newMessageText);"
          >
      </textarea>
      <button type="button" class="chat-send-button" [disabled]="!newMessageText || newMessageText.trim().length < 1" (pointerdown)="sendNewMessageFromPointer($event)" (keydown.enter)="submitNewMessage(newMessageText)">
        <i [class]="'chat.send' | nogoshIcon" aria-hidden="true"></i>
        <span class="sr-only">{{ 'common.send' | translate }}</span>
      </button>
    </form>
  </app-screen-shell>
}
